import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { componentsPropType, stylesPropType, vmPropTypes } from '../../../global-prop-types';
import ComponentsArrRenderer from '../../core/ComponentsArrRenderer';

const JmeGridDynamic = (props) => {
  const {
    variant, columns, parent, styles, ...restProps
  } = props;
  return (
    <div className={`row mx-0 ${variant || ''}`} style={styles?.wrapper}>
      {columns?.map((column, idx) => {
        const {
          components,
          id,
          variant: columnVariant,
          styles: stylesColumn,
          ...restColumn
        } = column;
        return (
          <div
            className={columnVariant || ''}
            key={id || uuid()}
            style={stylesColumn?.wrapper}
          >
            <ComponentsArrRenderer
              parent={[...parent, 'columns', idx]}
              components={components}
              {...restProps} // component props should go first
              {...restColumn} // column props should overwrite component props
            />
          </div>
        );
      })}
    </div>
  );
};

JmeGridDynamic.defaultProps = {
  variant: '',
  styles: { wrapper: {} },
  columns: []
};

JmeGridDynamic.vmPreview = {
  styles: { wrapper: { border: '2px solid black' } },
  columns: [
    {
      id: uuid(),
      variant: '',
      components: [
        {
          id: uuid(),
          componentName: 'JmeText',
          text: 'JmeText - Column 1'
        }
      ]
    },
    {
      id: uuid(),
      variant: '',
      hideWhen: ['xs', 'sm', 'md'],
      components: [
        {
          id: uuid(),
          componentName: 'JmeText',
          text: 'JmeText - Column 2'
        }
      ]
    }
  ]
};

JmeGridDynamic.propTypes = {
  variant: PropTypes.string,
  parent: PropTypes.array,
  componentName: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    components: componentsPropType
  }),),
  styles: stylesPropType
};

JmeGridDynamic.vmPropTypes = {
  variant: vmPropTypes.className,
  parent: vmPropTypes.arrayOfStrings,
  componentName: vmPropTypes.string,
  columns: vmPropTypes.arrayWithComponents,
  styles: { wrapper: vmPropTypes.styles }
};

export default JmeGridDynamic;
